import {
  PROJECT_TEMPLATES_FETCH,
  PROJECT_TEMPLATES_FETCH_SUCCESS,
  PROJECT_TEMPLATES_FETCH_FAILURE,
  PROJECT_TEMPLATE_CREATE,
  PROJECT_TEMPLATE_CREATE_SUBMIT,
  PROJECT_TEMPLATE_CREATE_FAILURE,
  PROJECT_TEMPLATE_DELETE,
  PROJECT_TEMPLATE_DELETE_SUCCESS,
  PROJECT_TEMPLATE_DELETE_FAILURE,
  PROJECT_TEMPLATE_UPDATE,
  PROJECT_TEMPLATE_UPDATE_SUBMIT,
  PROJECT_TEMPLATE_UPDATE_FAILURE,
  PROJECT_TEMPLATE_TOGGLE_ENABLE,
  PROJECT_TEMPLATE_TOGGLE_ENABLE_SUCCESS,
  PROJECT_TEMPLATE_TOGGLE_ENABLE_FAILURE
} from './constants'

export const projectTemplatesFetch = () => ({ type: PROJECT_TEMPLATES_FETCH })
export const projectTemplatesFetchSuccess = payload => ({ payload, type: PROJECT_TEMPLATES_FETCH_SUCCESS })
export const projectTemplatesFetchFailure = payload => ({ payload, type: PROJECT_TEMPLATES_FETCH_FAILURE })

export const projectTemplateCreate = payload => ({ payload, type: PROJECT_TEMPLATE_CREATE })
export const projectTemplateCreateSubmit = payload => ({ payload, type: PROJECT_TEMPLATE_CREATE_SUBMIT })
export const projectTemplateCreateFailure = payload => ({ payload, type: PROJECT_TEMPLATE_CREATE_FAILURE })

export const projectTemplateDelete = payload => ({ payload, type: PROJECT_TEMPLATE_DELETE })
export const projectTemplateDeleteSuccess = payload => ({ payload, type: PROJECT_TEMPLATE_DELETE_SUCCESS })
export const projectTemplateDeleteFailure = payload => ({ payload, type: PROJECT_TEMPLATE_DELETE_FAILURE })

export const projectTemplateUpdate = payload => ({ payload, type: PROJECT_TEMPLATE_UPDATE })
export const projectTemplateUpdateSubmit = payload => ({ payload, type: PROJECT_TEMPLATE_UPDATE_SUBMIT })
export const projectTemplateUpdateFailure = payload => ({ payload, type: PROJECT_TEMPLATE_UPDATE_FAILURE })

export const projectTemplateToggleEnable = payload => ({ payload, type: PROJECT_TEMPLATE_TOGGLE_ENABLE })
export const projectTemplateToggleEnableSuccess = payload => ({ payload, type: PROJECT_TEMPLATE_TOGGLE_ENABLE_SUCCESS })
export const projectTemplateToggleEnableFailure = payload => ({ payload, type: PROJECT_TEMPLATE_TOGGLE_ENABLE_FAILURE })
